import types from "../types"

/* remove */
export default function involve(model, actions) {
  return {
    type: types.batch,
    model,
    actions,
  }
}
